import { toI18n } from 'util/i18n';

// determines if current user has permission to edit a user profile
// returns properties and attributes for the edit button
export const editButtonAttrs = (
  currentProfile,
  currentUserId,
  isPayrollEnrolled = false
) => {
  let disableButton;
  let buttonContent;

  if (
    currentProfile.userId === currentUserId &&
    !currentProfile.disableBankAccountEditButton
  ) {
    disableButton = false;
    buttonContent = null;
  } else if (
    currentProfile.informationType === 'banking' &&
    currentProfile.disableBankAccountEditButton
  ) {
    // prevent users' that are not payroll admin
    // or payroll admins accessed by god mode from editing the banking info
    disableButton = true;
    buttonContent = toI18n(
      'product_usage.hover_text.only_payroll_admins_can_edit_bank_accounts'
    );
  } else if (
    isPayrollEnrolled &&
    currentProfile.informationType === 'banking' &&
    currentProfile.disableBankAccountsOps
  ) {
    // Prevent users from editing bank accounts if they don't have MFA enabled
    disableButton = true;
    buttonContent = toI18n('product_usage.hover_text.mfa_verification_text');
  } else if (
    isPayrollEnrolled &&
    currentProfile.informationType === 'banking' &&
    !currentProfile.disableBankAccountEditButton
  ) {
    // allow payroll admins users to edit the bank account
    // even if the user is in more than one company
    disableButton = false;
  } else {
    disableButton = currentProfile.moreThanOneCompany;
    buttonContent = toI18n('product_usage.hover_text.more_than_one_job', {
      props: {
        employee_name: currentProfile.userFullName,
        information_type: currentProfile.informationType,
      },
    });
  }
  return { disabled: disableButton, content: buttonContent };
};
